import { FolioSearchForm } from "@/components/FolioSearchForm";

export function HomePage() {
  return (
    <main className="grid min-h-screen lg:grid-cols-[1.05fr_1fr]">
      <section className="relative flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-900 to-indigo-900 px-8 py-16 text-white lg:px-16">
        <div className="absolute inset-0 opacity-30 [background-image:radial-gradient(circle_at_top_left,theme(colors.indigo.500)_0%,transparent_45%),radial-gradient(circle_at_bottom_right,theme(colors.emerald.400)_0%,transparent_40%)]" />
        <div className="relative z-10 max-w-md">
          <div className="mb-10 flex items-center gap-3">
            <div className="grid h-10 w-10 place-items-center rounded-xl bg-white/10 ring-1 ring-white/20">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="h-5 w-5 text-indigo-300"
                aria-hidden
              >
                <path d="M3 21h18" />
                <path d="M5 21V7l7-4 7 4v14" />
                <path d="M9 9h1" />
                <path d="M9 13h1" />
                <path d="M9 17h1" />
                <path d="M14 9h1" />
                <path d="M14 13h1" />
                <path d="M14 17h1" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-semibold tracking-wide">
                RPPC Jalisco
              </p>
              <p className="text-xs text-slate-400">Plataforma interna</p>
            </div>
          </div>

          <h1 className="text-4xl font-semibold leading-tight tracking-tight">
            Consulta jurídica
            <br />
            <span className="text-indigo-300">en un solo lugar.</span>
          </h1>
          <p className="mt-5 text-base leading-relaxed text-slate-300">
            Ingresa un número de folio del Registro Público de la Propiedad y
            Comercio del Estado de Jalisco y obtén la situación del inmueble,
            titulares, antecedentes y movimientos en un mismo tablero.
          </p>

          <ul className="mt-10 space-y-3 text-sm text-slate-300">
            {[
              "Estado de gravámenes y avisos en tiempo real",
              "Línea de tiempo cronológica de movimientos",
              "Reporte PDF listo para expediente del crédito",
            ].map((item) => (
              <li key={item} className="flex items-center gap-3">
                <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-500/20 text-emerald-300">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-3 w-3"
                    aria-hidden
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="flex items-center justify-center bg-slate-50 px-8 py-16 lg:px-16">
        <div className="w-full max-w-md">
          <h2 className="text-2xl font-semibold tracking-tight text-slate-900">
            Consultar un folio
          </h2>
          <p className="mt-2 text-sm text-slate-600">
            Escribe el número de folio registral. La consulta abre el tablero
            del inmueble con la información jurídica vigente.
          </p>

          <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-card">
            <FolioSearchForm />
          </div>
        </div>
      </section>
    </main>
  );
}
